export default "__VITE_ASSET__xr1qI_E1__"